// Translation: Terms of service > Landing > Form (Arabic)
export default Object.freeze({})
